import axios from "axios";
import { api } from "./helper";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

function GetTrackingStatus(claimId) {
    return client.get("TrackingStatus/GetTrackingStatus/" + claimId);
}

function GetTrackingInfo(trackId) {
    return client.get("TrackInfo/GetTrackingInfo/" + trackId);
}

export {
    GetTrackingStatus,
    GetTrackingInfo
}
